// removed by extract-text-webpack-plugin
module.exports = {"message":"_3xHhQN3oR2haE2iacGkirL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RecipientsImportsErrors/RecipientsImportsErrors.scss
// module id = 1310
// module chunks = 1